import React from 'react'
import Header from '../Components/Header'
import Footer from '../Components/Footer'
import Pagetitle from '../Components/Pagetitle'
import TrendingProducts from '../Components/TrendingProducts'


function DesiCowGhee() {
  return (
    <>
      <main className="container-fluid">
    <Header />
    <Pagetitle />
    
    <TrendingProducts/>
    <Footer />
    </main>
    </>
  )
}

export default DesiCowGhee